"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadImportFile = void 0;
const BaseClient_1 = require("@juvare/platform-sdk-js/BaseClient");
function downloadImportFile(param) {
    return __awaiter(this, void 0, void 0, function* () {
        if (BaseClient_1.baseClientDefaults.tokenProvider) {
            const jwt = yield BaseClient_1.baseClientDefaults.tokenProvider.onTokenRequest();
            downloadFileUsingJwt(param, jwt);
        }
        else {
            window.open(getAttachmentUrl(param), '_blank');
        }
    });
}
exports.downloadImportFile = downloadImportFile;
function downloadFileUsingJwt(param, jwt) {
    const form = document.createElement('form');
    form.method = 'post';
    form.target = '_blank';
    form.action = BaseClient_1.baseClientDefaults.baseUrl + '/api/v1/import/getResults';
    const inputs = [];
    inputs.push(`<input type="hidden" name="id" value="${param.id}">`);
    inputs.push(`<input type="hidden" name="jwt" value="${jwt}">`);
    if (param.downloadFileName) {
        inputs.push(`<input type="hidden" name="downloadFileName" value="${param.downloadFileName}">`);
    }
    form.innerHTML = inputs.join();
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
}
function getAttachmentUrl(param) {
    const baseUrl = BaseClient_1.baseClientDefaults.baseUrl;
    const id = encodeURIComponent(param.id);
    const downloadFileNameParam = param.downloadFileName ? '&downloadFileName=' + encodeURIComponent(param.downloadFileName) : '';
    return `${baseUrl}/api/v1/import/getResults?id=${id}${downloadFileNameParam}`;
}
